import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_AuthorizationToRelease = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GENERAL_AuthorizationToRelease' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <strong>I, the undersigned, hereby authorize
                        <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only w-200 custom-add-only' />
                        to use or disclose my personal health information and/or confidential information as described below to:</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Name of Recipient</span></td>
                        <td className='w-250'><span className='eleHeader'>Phone</span></td>
                        <td className='w-250'><span className='eleHeader'>Fax</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtNameRecipient" name="txtNameRecipient" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPhone" name="txtPhone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFax" name="txtFax" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Address (Street)</span></td>
                        <td className='w-250'><span className='eleHeader'>(City) (State)</span></td>
                        <td className='w-250'><span className='eleHeader'>(Zip)</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtAddress" name="txtAddress" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtCity" name="txtCity" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtZip" name="txtZip" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" name="cbAuthorization_1" id="cbAuthorization_1" className='add-only' value="Authorization_1" />If marked, I further authorize the <strong>EXCHANGE</strong>  of information and for the party identified as Recipient above to also disclose my personal health information and/or confidential information to

                    <input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only w-200 custom-add-only' />
                    .
                </p>
                <h3>Type of Information to be Released/Exchanged:</h3>
                <table>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_1" id="cbAuthorizationInformation_1" className='add-only' value="AuthorizationInformation_1" />Mental Health Assessments/Evaluations</td>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_2" id="cbAuthorizationInformation_2" className='add-only' value="AuthorizationInformation_2" />Partial Hospitalization Records</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_3" id="cbAuthorizationInformation_3" className='add-only' value="AuthorizationInformation_3" />Alcohol/Drug Assessment (LOC)</td>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_4" id="cbAuthorizationInformation_4" className='add-only' value="AuthorizationInformation_4" />Treatment Plan/ITP/Treatment Updates</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_5" id="cbAuthorizationInformation_5" className='add-only' value="AuthorizationInformation_5" />HIV/AIDS Related Diagnosis</td>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_6" id="cbAuthorizationInformation_6" className='add-only' value="AuthorizationInformation_6" />Alcohol/Drug Treatment Summary</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_7" id="cbAuthorizationInformation_7" className='add-only' value="AuthorizationInformation_7" />Progress Notes</td>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_8" id="cbAuthorizationInformation_8" className='add-only' value="AuthorizationInformation_8" />Court Reports</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_9" id="cbAuthorizationInformation_9" className='add-only' value="AuthorizationInformation_9" />Alcohol/Drug Treatment Plan</td>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_10" id="cbAuthorizationInformation_10" className='add-only' value="AuthorizationInformation_10" />Psychological Information</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_11" id="cbAuthorizationInformation_11" className='add-only' value="AuthorizationInformation_11" />Psychiatric Information</td>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_12" id="cbAuthorizationInformation_12" className='add-only' value="AuthorizationInformation_12" />Alcohol/Drug Progress Notes</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_13" id="cbAuthorizationInformation_13" className='add-only' value="AuthorizationInformation_13" />General Medical Records <br />(except HIV/AIDS related diagnosis and treatment)</td>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_14" id="cbAuthorizationInformation_14" className='add-only' value="AuthorizationInformation_14" />Employment Records </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_15" id="cbAuthorizationInformation_15" className='add-only' value="AuthorizationInformation_15" />Alcohol/Drug Discharge Plan</td>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_16" id="cbAuthorizationInformation_16" className='add-only' value="AuthorizationInformation_16" />School Reports/Records/IEPIMFE</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_17" id="cbAuthorizationInformation_17" className='add-only' value="AuthorizationInformation_17" />Urinalysis/Breathalyzer Results</td>
                        <td className='w-375'><input type="checkbox" name="cbAuthorizationInformation_18" id="cbAuthorizationInformation_18" className='add-only' value="AuthorizationInformation_18" /> Discharge Summary</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" name="cbAuthorizationInformation_19" id="cbAuthorizationInformation_19" className='add-only' value="AuthorizationInformation_19" />Other (specify):</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="text" name="txtAuthorizationInformation_19" id="txtAuthorizationInformation_19" className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Dates of Service to Release (FROM):</span></td>
                        <td className='w-375'><span className='eleHeader'>(TO):</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="dtDatesService" name="dtDatesService" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="dtTo" name="dtTo" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Purpose for Disclosure:</h3>
                <table>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbPurposeDisclosure_1" id="cbPurposeDisclosure_1" className='add-only' value="PurposeDisclosure_1" />Care/Treatment/Ongoing</td>
                        <td className='w-375'><input type="checkbox" name="cbPurposeDisclosure_2" id="cbPurposeDisclosure_2" className='add-only' value="PurposeDisclosure_2" />Treatment Planning</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbPurposeDisclosure_3" id="cbPurposeDisclosure_3" className='add-only' value="PurposeDisclosure_3" />Assessment/Evaluation</td>
                        <td className='w-375'><input type="checkbox" name="cbPurposeDisclosure_4" id="cbPurposeDisclosure_4" className='add-only' value="PurposeDisclosure_4" />To follow up on a referral</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbPurposeDisclosure_5" id="cbPurposeDisclosure_5" className='add-only' value="PurposeDisclosure_5" />Continuity of Care </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" name="cbPurposeDisclosure_6" id="cbPurposeDisclosure_6" className='add-only' value="PurposeDisclosure_6" />Other, please specify: <br />  <input type="text" name="txtPurposeDisclosure_1" id="txtPurposeDisclosure_1" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    I understand and acknowledge that the requested information may contain information regarding physical and mental illness, HIV test
                    results or diagnosis, AIDS or AIDS related conditions, alcohol and/or drug dependence/abuse*. I also understand that information used or
                    disclosed according to this authorization may be subject to re-disclosure by the recipient and may no longer be protected. <br /><br />

                    I understand that I may see and copy the information described on this form if requested in writing. I also understand that the provider
                    may not condition treatment, payment, enrollment or eligibility for benefits on whether I sign this authorization. The health care
                    providers listed above will not receive financial or in-kind compensation in exchange for using or disclosing my health care information. <br /><br />

                    I understand I have a right to revoke this authorization (in writing) at any time. I understand that the revocation will not apply to
                    information that has already been released in response to this authorization. If not revoked, <strong>this authorization will expire one year from the date written below </strong>
                    or on the following date, event or condition (if earlier):
                    <input type="text" name="txtPurposeDisclosure_2" id="txtPurposeDisclosure_2" className='add-only' /> <br /> <br />

                    I understand there may be charges for the copying and release of information and accept financial responsibility for those charges. I
                    understand and agree that a copy of this authorization shall have the same force and effect as the original.
                </p>
                <table>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-250 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Signature of Client </td>
                        <td className="w-250 small">Printed Name</td>
                        <td className="w-150 small">Date</td>
                    </tr>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-250 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Signature of Parent/Legal Guardian/ Personal Representative** </td>
                        <td className="w-250 small">Printed Name</td>
                        <td className="w-150 small">Date</td>
                    </tr>
                </table>
                <p className='w-750'><i>* Prohibition Against Re-Disclosure: This information has been disclosed to you from records protected by federal confidentiality rules. The federal rules
                    prohibit any further disclosure of this information unless further disclosure is expressly permitted by the written consent of the person to whom it pertains
                    or as otherwise permitted by 42 C.F.R. Part 2. A general authorization for the release of medical or other information is NOT sufficient for this purpose. The
                    federal rules restrict any use of information to criminally investigate or prosecute and alcohol or drug abuse client. ** If other than client's signature, a copy
                    of legal paperwork verifying the client's personal representative MUST accompany the request unless otherwise on file with provider (e.g., court appointed
                    guardian, durable power of attorney for healthcare, grandparent power of attorney). Exception: Parent signing for client under the age of eighteen and the
                    County agency holding custody.
                </i></p>
                <h3>Revocation of Authorization for Release of Information</h3>
                <p className='w-750'>
                    At the date and time noted below, I hereby revoke permission for

                    <input type='text' id='txtProviderName_3' name='txtProviderName_3' className='add-only w-200 custom-add-only' />
                    to further release information to the above-noted person, except to
                    the extent the program has already acted in reliance upon it.
                </p>
                <table>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>

                    </tr>
                    <tr>
                        <td className="w-375 small">Signature of Parent/Legal Guardian/ Personal Representative** </td>
                        <td className="w-375 small">Date</td>
                    </tr>
                </table>
            </div>
        </form>

    )
}





















